import React from 'react'
import HeroSection from '../../HeroSection';

import { homeObjTwo } from '../HomePage/Data';


function Products() {
    return (
        <>
                  
                  
                   
                   <HeroSection {...homeObjTwo} />
                  
        </>
    )
}

export default Products
